<template>
    <div
        class="form-group"
        :class="{'has-error': error.length}"
    >
        <label
            class="control-label"
            :for="name"
            v-if="label.length"
            v-text="label"
        ></label>
        <slot></slot>
        <div
            class="help-block"
            v-if="error.length"
            v-text="error"
        ></div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'InputWrapper',

    props: {
        errors: {
            default: () => ({}),
            required: false,
            type: Object,
        },
        label: {
            default: '',
            required: false,
            type: String,
        },
        name: {
            default: '',
            required: false,
            type: String,
        },
    },

    computed: {
        error() {
            return this.hasErrors
                ? Object.values(this.errors)[0]
                :'';
        },
        hasErrors() {
            return !_.isEmpty(this.errors);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputWrapper.vue